import { render, staticRenderFns } from "./BarcodeToast.vue?vue&type=template&id=873358a6&"
import script from "./BarcodeToast.vue?vue&type=script&lang=js&"
export * from "./BarcodeToast.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports